/* eslint-disable */
require('./16')
require('./34')
require('./5')
require('./alert-circle')
require('./chevron-down')
require('./close')
require('./courbe')
require('./grill')
require('./ic_api')
require('./ic_arc')
require('./ic_arrow')
require('./ic_back')
require('./ic_bank')
require('./ic_bike')
require('./ic_car')
require('./ic_close')
require('./ic_db')
require('./ic_elipse')
require('./ic_entreprise')
require('./ic_espece')
require('./ic_flech')
require('./ic_form_down')
require('./ic_health')
require('./ic_healthcare')
require('./ic_home')
require('./ic_insurance')
require('./ic_itineraire')
require('./ic_link')
require('./ic_menu_b')
require('./ic_menu')
require('./ic_message')
require('./ic_money_var')
require('./ic_multicanal')
require('./ic_next')
require('./ic_person')
require('./ic_plane')
require('./ic_prev')
require('./ic_saas')
require('./ic_setting')
require('./ic_suivi')
require('./ic_touch')
require('./ic_triange')
require('./ic_user')
require('./ic_wallet')
require('./logo')
require('./validCircle')
